import { linkAllVariantsAction as linkAllVariantsOperation } from 'editor/src/store/variants/slice';

export default linkAllVariantsOperation;
